import axios from "axios";
import Cookies from "js-cookie";

// export const API_BASE_URL = "http://localhost:5173";    
export const API_BASE_URL = "https://app.runanalytic.com";

export const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Add a request interceptor to automatically add the Bearer token
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);